// View model for the "needs exception" banner: deposits landed in the 400–499.99 band, so the comp
// can only be issued as a one-off manager exception. Amounts stay exact (integer cents).
import { centsText, decimalCents } from './format';
import { formatMoney, TOTAL_CHECKS } from './notEligible';

const BAND_REASON = /400.499\.99 band/;

// pct of part in whole, 2 decimals, clamped to 0–100.
const pct = (part, whole) => (whole > 0 ? Math.round(Math.min(1, Math.max(0, part / whole)) * 10000) / 100 : 0);

// When an exception fits (VIP guidelines, "Discretion and leniency"); onWagering35x is ticked
// when the player's tags resolve to 35x.
const GUIDANCE = [
  { key: 'spent', text: 'Has spent a lot today, or received a few VIP comps today' },
  { key: 'regular', text: 'Usually a good depositor in a dry spell, or back after a long absence' },
  { key: 'wagering35', text: 'Is on 35x wagering' },
];

// needsExceptionView describes the exception band, or null for any other decision.
export const needsExceptionView = (check) => {
  if (check?.decision !== 'needs_exception') return null;
  const d = check.deposits || {};
  const currency = d.basis_currency || 'USD';
  const measured = decimalCents(d.measured || '0');
  const eligible = decimalCents(d.eligible_min || '0');
  const band = decimalCents(d.exception_min || '0');
  const short = formatMoney(centsText(Math.max(0, eligible - measured)), currency);
  const on35x = check.wagering?.status === 'determined' && check.wagering?.wagering === 35;
  return {
    eyebrow: `Manager decision · All ${TOTAL_CHECKS} checks ran`,
    title: `${short} short of the full comp`,
    text: 'Deposits are in the exception band. The comp can be issued as a one-off exception — tell the player it is a one-off.',
    metrics: [
      { label: 'Deposited this period', value: formatMoney(d.measured || '0.00', currency) },
      { label: 'Exception band from', value: formatMoney(d.exception_min, currency) },
      { label: 'Full comp from', value: formatMoney(d.eligible_min, currency) },
      { label: 'Short by', value: short, accent: true },
    ],
    bar: {
      pct: pct(measured, eligible),
      bandPct: pct(band, eligible),
      left: `${formatMoney(d.measured || '0.00', currency)} deposited`,
      right: `${formatMoney(d.eligible_min, currency)} full comp`,
    },
    guidance: GUIDANCE.map((g) => ({ ...g, met: g.key === 'wagering35' && on35x })),
    // the band itself is the headline; anything else (e.g. wagering) still needs attention
    reasons: (check.reasons || []).filter((r) => !BAND_REASON.test(r)),
  };
};
